import { ExecuteEndpoint } from '../../components/common/BaseApiService';

export class ConfigurationService {
  public async getAllowedFileExtensions(): Promise<string[]> {
    return ExecuteEndpoint(`configuration/allowed-extensions`, 'GET');
  }

  public async getPrivateViewsLimit(indexId: number): Promise<number> {
    return ExecuteEndpoint(`configuration/priv-views-limit?indexId=${indexId}`, 'GET');
  }

  public async getGlobalFiltersLimit(indexId: number): Promise<number> {
    return ExecuteEndpoint(`configuration/global-filters-limit?indexId=${indexId}`, 'GET');
  }

  public async getMultiFileUploadLimit(indexId: number): Promise<number> {
    return ExecuteEndpoint(`configuration/file-upload-limit?indexId=${indexId}`, 'GET');
  }
}
